const translateAlt = {
  chinaFlag: '中国国旗',
  malaysiaFlag: '马来西亚国旗',
  britainFlag: '英国国旗',
};

export default translateAlt;
